import { Component, Input, OnInit, Type } from '@angular/core';
import { Alert } from '../../models/alert.interfaces';
import { NgxSpinnerService } from 'ngx-spinner';
import { PanelService } from 'src/app/panel/services/panel.service';
import { EventService } from 'src/app/events/services/event.service';
import { AlertService, TypeAlert } from 'src/app/alertas/services/alert.service';
import Swal from 'sweetalert2';
import { ChangeDetectorRef } from '@angular/core';


@Component({
  selector: 'app-alerts-list',
  templateUrl: './alerts-list.component.html',
  styleUrls: ['./alerts-list.component.scss']
})
export class AlertsListComponent implements OnInit {
  @Input() type : TypeAlert | undefined;

  public alerts:Alert[] = [];
  filteredAlerts: any[] = []; // Lista filtrada para mostrar
  groupedAlertsTree: {
    id: string;
    nombre: string;
    isOpen: boolean;
    alerts: any[];
  }[] = [];

  public showByTable = false;
  public expandedCards = true;
  // indica si esta en un panel donde se muestra todas las alertas o solo de un tipo
  public isAll: boolean = true; 

  constructor(
    public alertService: AlertService,
    private spinner: NgxSpinnerService,
    public panelService: PanelService,
    public eventService: EventService,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.spinner.show('loadingAlertsSpinner');
    this.loadAlerts().then(()=>{
      this.spinner.hide('loadingAlertsSpinner');
      this.aplicarFiltroGlobal()
    })
    let selectedView = this.alertService.alertConfig.viewMode
    this.showByTable = selectedView == "table";
    this.expandedCards = this.alertService.alertConfig.showExpanded;
  }


  private async loadAlerts(){

    if(this.type){
      this.alerts = await this.alertService.getAlertsByType(this.type)
      this.isAll = false;
    } else {
      this.alerts = await this.alertService.getAll()
      this.isAll = true;
    }

    this.alerts.forEach((alert) => {
      const imeis = (alert.imei || '').split(',').filter(i => i.trim() !== '');
      alert.imeiCount = imeis.length;
      alert.isActive = alert.activo == "true";
      if(this.isAll){
        alert.isActive = alert.activo_bol
        alert.isActiveSoundSystem = alert.sonido_sistema_bol
        alert.isActiveNotificationEmail = alert.notificacion_email_bol
        alert.isActiveNotificationWhatsapp = alert.notificacion_whatsapp ? alert.notificacion_whatsapp.toLowerCase() === 'true' : false;
      } else {
        alert.isActive = alert.activo == "true"
        alert.isActiveNotificationWhatsapp = alert.notificacion_whatsapp ? alert.notificacion_whatsapp.toLowerCase() === 'true' : false;
        alert.isActiveNotificationEmail = alert.notificacion_email.toLowerCase() === 'true'
        let arrayNotificationSystem = alert.sistema_notificacion.split(',');
        alert.isActiveSoundSystem = (arrayNotificationSystem[2].toLowerCase() === 'true');
      }
    });
    console.log("alert list : ", this.alerts)
  }


  private sectionPanelToCreate : any = {
    [TypeAlert.GPS] : 'ALERTS-GPS-CREATE',
    [TypeAlert.PLATAFORM] : 'ALERTS-PLATFORM-CREATE',
    [TypeAlert.SECURITY] : 'ALERTS-SECURITY-CREATE',
    [TypeAlert.MOBILE] : 'ALERTS-MOBILE-CREATE',
    [TypeAlert.ALERT_360] : 'ALERTS-360-CREATE',
  }

  public clickCreateNewAlert() {
    $("#panelMonitoreo").show( "slow" );
    if(!this.isAll && this.type){
      this.panelService.nombreComponente = this.sectionPanelToCreate[this.type];
    }
  }

  public panelCreateNewAlert(typeAlert : string) {
    $("#panelMonitoreo").show( "slow" );
    if(typeAlert && this.sectionPanelToCreate[typeAlert]){
      this.panelService.nombreComponente = this.sectionPanelToCreate[typeAlert];
    }
  }

  // options by Alert
  editAlert(alertId : any){
    let alert = this.alerts.find( (alert: Alert) => alert.id == alertId);
    this.alertService.alertEdit = alert;

    $("#panelMonitoreo").show( "slow" );

    switch (alert?.event_type) {
      case TypeAlert.SECURITY:
        this.panelService.nombreComponente = "ALERTS-SECURITY-EDIT";
        this.panelService.nombreCabecera = "Alerta Seguridad Vehicular";
        break;

      case TypeAlert.MOBILE:
        this.panelService.nombreComponente = "ALERTS-MOBILE-EDIT";
        this.panelService.nombreCabecera = "Alerta Solución Móvil";
        break;

      case TypeAlert.GPS:
        this.panelService.nombreComponente = "ALERTS-GPS-EDIT";
        this.panelService.nombreCabecera = "Alerta GPS";
        break;

      case TypeAlert.PLATAFORM:
        this.panelService.nombreComponente = "ALERTS-PLATFORM-EDIT";
        this.panelService.nombreCabecera = "Alerta Plataforma";
        break;

      case TypeAlert.ALERT_360:
      default:
        this.panelService.nombreComponente = "ALERTS-360-EDIT";
        this.panelService.nombreCabecera = "Alerta Fatiga 360";
        break;
    }
  }
  deleteAlert(event : any, alert : any) {
    event.preventDefault();

    Swal.fire({
        title: '¿Está seguro?',
        text: `¿Está seguro que desea eliminar ${alert.nombre}?`,
        showCancelButton: true,
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cancelar',
        preConfirm:async () => {
          try{
            const res = await this.alertService.delete(alert.id);
            this.loadAlerts().then(()=>{
              this.aplicarFiltroGlobal()
            })
          } catch {
            Swal.fire(
              'Error',
              'No se pudo eliminar el registro. Por favor, inténtalo de nuevo.',
              'error'
            );
            this.loadAlerts().then(()=>{
              this.aplicarFiltroGlobal()
            })
          }
        }
    }).then(data => {
      if(data.isConfirmed){
        Swal.fire(
          'Eliminado',
          '¡Los datos se eliminaron correctamente!',
          'success'
        );
      }
    });
  }

  public globalFilterValue : string = ""
  aplicarFiltroGlobal() {
    const filtro = this.globalFilterValue.toLowerCase().trim();

    if (!filtro) {
      this.filteredAlerts = [...this.alerts];
    } else {
      this.filteredAlerts = this.alerts.filter(alert =>
        (alert.nombre?.toLowerCase().includes(filtro)) ||
        (alert.tipo?.toLowerCase().includes(filtro)) ||
        (alert.event_type?.toLowerCase().includes(filtro))
      );
    }

    // Aplica la agrupación con los datos filtrados
    this.groupAlertsByEventType();
  }
  public showGroupAlerts() {
    this.showByTable = !this.showByTable
  }

  groupAlertsByEventType() {
    const orderedTypes = [
      { id: TypeAlert.GPS, nombre: "Alertas GPS Tracker" },
      { id: TypeAlert.PLATAFORM, nombre: "Alertas plataforma" },
      { id: TypeAlert.SECURITY, nombre: "Alertas seguridad vehicular" },
      { id: TypeAlert.MOBILE, nombre: "Alertas soluciones móviles" },
      { id: TypeAlert.ALERT_360, nombre: "Alertas fatiga 360" },
    ];

    const map = new Map<string, any>();

    // 🔹 Inicializar grupos si `isAll` está activado
    if (this.isAll) {
      for (const { id, nombre } of orderedTypes) {
        map.set(id, {
          id,
          nombre,
          alerts: [],
          isOpen: false, // por defecto cerrado
        });
      }
    }

    // 🔹 Agrupar alertas por tipo
    for (const alert of this.filteredAlerts) {
      const type = alert.event_type;
      if (!type) continue;

      if (!map.has(type)) {
        const tipoInfo = orderedTypes.find(t => t.id === type);
        if (!tipoInfo) continue;

        map.set(type, {
          id: type,
          nombre: tipoInfo.nombre,
          alerts: [],
          isOpen: false, // se evaluará después
        });
      }

      map.get(type).alerts.push(alert);
    }

    // 🔹 Construir lista final y definir `isOpen` correctamente
    this.groupedAlertsTree = orderedTypes
      .map(({ id }) => {
        const group = map.get(id);
        if (!group) return undefined;

        // ✅ Regla: si tiene alertas => sigue expandedCards, si no => cerrado
        group.isOpen = group.alerts.length > 0 ? this.expandedCards : false;
        return group;
      })
      .filter(Boolean); // eliminar undefined

    this.cdr.detectChanges();
  }


}
